<template>
  <div class="sidebar">
    <SideBarFilters
      class="sbf"
      @date-change="dateChangedOnSideBarPicker"
      @option-chosen="userChooseOption"
      :selectedOption="selectedOption"
      :options="options"/>
    <Navdrawer
      class="ndf"
      @option-chosen="userChooseOption"
      :selectedOption="selectedOption"
      :options="options"/>
  </div>
</template>

<script>
import { computed } from "vue";
import Navdrawer from "@/components/navdrawer.vue";
import SideBarFilters from "@/containers/desktop/SideBarFilters.vue";
import { useMenuStore } from "@/stores/menu.ts";
 
export default {
  name: "Sidebar",
  emits: ["optionChosen","dateChange"],
  components: {
    Navdrawer,
    SideBarFilters,
  },
  setup(){
    //#region Store Managment
    const menuStore = useMenuStore();
    const options = computed(() => menuStore.menuItems);
    const selectedOption = computed(() => menuStore.currentSelected)
    return {
      options,
      selectedOption
    }
    //#endregion
  },
  methods: {
    dateChangedOnSideBarPicker(data) {
      this.$emit("dateChange",data);
    },
    userChooseOption(option) {
      this.$emit("optionChosen",option);
    },
  },
};
</script>

<style scoped>
.sidebar {
  flex-shrink: 0;
  background: #f6f6f6;
  z-index: 51;
}

.sbf{
  display: block;
  width: 295px;
}

.ndf{
  display: none;
}


@media screen and (max-width:1024px) {
  .sbf{
    display: none;
  }

  .ndf{
    display: block;
    padding-left: 0;
  }  

  .sidebar{
    -webkit-box-flex: 0;
    -ms-flex: 0 0 8.33333%;
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }
}
</style>
